import { request } from '@/api/request';

const fetchInvite = (id: string) => request('GET', `/federated-invites/${id}`);

const fetchInvites = () => request('GET', '/federated-invites');

const sendInvite = (organisationName: string, contactEmail: string) =>
  request('POST', '/federated-invites', { organisationName, contactEmail });

const cancelInvite = (id: string) => request('POST', `/federated-invites/${id}/cancel`);

const acceptInvite = (id: string) => request('POST', `/federated-invites/${id}/accept`);

export const live = {
  fetchInvite,
  fetchInvites,
  sendInvite,
  cancelInvite,
  acceptInvite,
};

const api = { ...live };
export default api;

export const replaceAPI = (newApi: Record<string, any>) => {
  Object.keys(newApi).forEach((i) => {
    (api as any)[i] = newApi[i];
  });
};
